import React, { useEffect } from 'react';
import '../BillingStyle/BillingMain.css';

const bars = [40, 60, 45, 75, 58, 85, 50, 90, 65, 78, 55, 100];
const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

const BillingMain = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('[data-animate-bill]').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="bill-hero">
      <div className="bill-hero-orb1"></div>
      <div className="bill-hero-orb2"></div>

      <div className="bill-hero-inner">
        {/* Text */}
        <div className="bill-hero-text" data-animate-bill>
          <div className="bill-eyebrow">
            <i className="bi bi-receipt-cutoff"></i>
            Billing &amp; Invoicing Platform
          </div>
          <h1 className="bill-hero-title">
            Flexible Billing Software That
            <span className="bill-hero-highlight"> Scales With You</span>
          </h1>
          <p className="bill-hero-desc">
            Automate invoicing, handle GST compliance, track payments, and generate real-time
            financial reports — all in one powerful platform built for Indian businesses.
          </p>
          <ul className="bill-hero-features">
            {[
              'Automated GST-compliant invoicing',
              'Real-time payment tracking & analytics',
              'Multi-format reports (PDF, Excel, CSV)',
              'Integrated TDS & tax calculations',
            ].map((f, i) => (
              <li key={i}><i className="bi bi-check-circle-fill"></i> {f}</li>
            ))}
          </ul>
          <div className="bill-hero-stats">
            <div className="bill-stat">
              <span className="bill-stat-num">₹12.4L+</span>
              <span className="bill-stat-lbl">Revenue Tracked</span>
            </div>
            <div className="bill-stat-divider"></div>
            <div className="bill-stat">
              <span className="bill-stat-num">248+</span>
              <span className="bill-stat-lbl">Invoices Generated</span>
            </div>
            <div className="bill-stat-divider"></div>
            <div className="bill-stat">
              <span className="bill-stat-num">99%</span>
              <span className="bill-stat-lbl">Accuracy Rate</span>
            </div>
          </div>
        </div>

        {/* Dashboard visual */}
        <div className="bill-hero-visual" data-animate-bill>
          <div className="bill-dashboard">
            <div className="bill-dash-header">
              <div className="bill-dash-title">
                <i className="bi bi-bar-chart-line-fill"></i>
                Billing Dashboard
              </div>
              <span className="bill-dash-live">
                <span className="bill-dash-dot"></span> Live
              </span>
            </div>

            <div className="bill-dash-stats">
              {[
                { val: '₹12.4L', lbl: 'Revenue', trend: '+18%', up: true },
                { val: '248',    lbl: 'Invoices', trend: '+32',  up: true },
                { val: '₹1.2L', lbl: 'Pending',  trend: '-5%',  up: false },
              ].map((s, i) => (
                <div key={i} className="bill-dash-stat">
                  <div className="bill-dash-stat-val">{s.val}</div>
                  <div className="bill-dash-stat-lbl">{s.lbl}</div>
                  <div className={`bill-dash-stat-trend ${s.up ? 'up' : 'down'}`}>
                    <i className={`bi ${s.up ? 'bi-arrow-up' : 'bi-arrow-down'}`}></i>{s.trend}
                  </div>
                </div>
              ))}
            </div>

            <div className="bill-dash-chart">
              {bars.map((h, i) => (
                <div key={i} className="bill-dash-bar-wrap">
                  <div
                    className={`bill-dash-bar ${i === 11 ? 'current' : ''}`}
                    style={{ height: `${h}%`, animationDelay: `${i * 0.06}s` }}
                  ></div>
                </div>
              ))}
            </div>
            <div className="bill-dash-chart-labels">
              {months.map((m, i) => <span key={i}>{m}</span>)}
            </div>

            <div className="bill-dash-txns">
              <div className="bill-dash-txn-title">Recent Transactions</div>
              {[
                { name: 'Kalyani Traders',    amt: '₹45,000', status: 'paid' },
                { name: 'Reddy & Associates', amt: '₹28,500', status: 'pending' },
                { name: 'Deccan Infoworks',   amt: '₹72,000', status: 'paid' },
              ].map((t, i) => (
                <div key={i} className="bill-dash-txn">
                  <span className="bill-dash-txn-name">{t.name}</span>
                  <span className={`bill-dash-badge ${t.status}`}>{t.status}</span>
                  <span className="bill-dash-txn-amt">{t.amt}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BillingMain;
